import { useEffect, useRef } from "react";
import { platform } from "@/platform";
import { t } from "@/i18n/ko";
import { useOtaProgress } from "@/app/otaUpdate";
import { playSplashMotion } from "./splashMotion";
import "./splash.css";

/**
 * F01-01 스플래시 = 루트 loader(부팅) 동안의 HydrateFallback. M-1 「담기 · 레드」 모션(splashMotion)을 1회 재생하고 마지막 프레임에서 부팅을 기다린다.
 * 앱(AC0-90): 시스템 스플래시(Android 12+ splash_cat · iOS LaunchScreen = M-1 0프레임)가 먼저 보이고, 이 화면이 그려지면
 * 네이티브 스플래시를 내려 이어받는다(@capacitor/splash-screen launchAutoHide:false). 웹은 hideSplash 가 no-op.
 */
export function SplashPage() {
  const percent = useOtaProgress((s) => s.percent);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const stop = canvasRef.current ? playSplashMotion(canvasRef.current) : undefined;
    void platform.app.hideSplash();
    return stop;
  }, []);
  return (
    <div className="splash" role="status" aria-label={t("app.name")}>
      <canvas ref={canvasRef} className="splash__motion" aria-hidden="true" />
      {/* OTA(AC0-170): iOS 플러그인은 zip 전송 중 진행률을 주지 않아(0 → 받은 뒤 70·90·100) 수치 대신 움직이는 막대 */}
      {percent !== null && (
        <div className="splash__ota" role="progressbar" aria-label={t("ota.updating")}>
          <p className="splash__ota-label">{t("ota.updating")}</p>
          <div className="splash__ota-track">
            <div className="splash__ota-bar" />
          </div>
        </div>
      )}
    </div>
  );
}
